import React from 'react';
import {styleForHeader} from '../../style.js';

export const GridColumns = [
    { field: 'id', hide: true},
    { field: 'name', width: 200, headerAlign:'center', text:'SÜREÇ ŞABLON ADI',
        renderHeader: () => styleForHeader('SÜREÇ ŞABLON ADI')
    },
    { field: 'notificationType', width: 150, headerAlign:'center', text:'BİLDİRİM TİPİ',
        renderHeader: () => styleForHeader('BİLDİRİM TİPİ')
    },
    { field: 'notificationTo', width: 200, headerAlign:'center', align:'center', text:'BİLDİRİMİN GİDECEĞİ KİŞİ',
        renderHeader: () => styleForHeader('BİLDİRİMİN GİDECEĞİ KİŞİ'),
    },
    { field: 'signersOrderType', width: 150, headerAlign:'center', text:'İMZACI SIRASI',
        renderHeader: () => styleForHeader('İMZACI SIRASI')
    },          
    { field: 'recordStatus', hide: true},
    { field: 'internalSigners',type:'array',text:'İç İmzacılar',
    arrayColumns:[
        { field: 'id', hide: true },
        { 
            field: 'userInfo',type:'singleSelect',labelText:'Kullanıcı',
            renderCell: (params) => (<div>{params.value.name}</div>),
            dataList:[{name:"Muslera",id:1},{name:"Nelsson",id:3},{name:"Mertens",id:7},{name:"Icardi",id:9},{name:"Mata",id:10}],
            keyField:'id',valueField:'name'
        },
        { field: 'signType' },
        { field: 'recordStatus', hide: true }
      ],columnVisibilityModel:{id:false,recordStatus:false}},
      { field: 'externalSigners',type:'array',text:'Dış İmzacılar',
      arrayColumns:[
        { field: 'id', hide: true },
        { 
            field: 'userInfo',type:'singleSelect',labelText:'Kullanıcı',
            renderCell: (params) => (<div>{params.value.name}</div>),
            dataList:[{name:"Muslera",id:1},{name:"Nelsson",id:3},{name:"Mertens",id:7},{name:"Icardi",id:9},{name:"Mata",id:10}],
            keyField:'id',valueField:'name'
        },
        { field: 'signType' },
        { field: 'recordStatus', hide: true }
      ],columnVisibilityModel:{id:false,recordStatus:false}}
];
